<template>

    <button class="spin-the-wheel__launch-button" @click="openWheel">

        <img :src="AppConfigs.staticImages.SPINTHEWHEEL" class="w-75" :class="{ 'spin-the-wheel__launch-button--spinning': !cantSpin, 'disabled': cantSpin }" />
        <WheelTimer class="spin-the-wheel__timer-position" :endTime="timerEndTime" />

    </button>


    <WheelDialog />

</template>



<script lang="ts" setup>

import { AppConfigs } from "@/app.configs";
import { ref, provide, computed } from "vue";
import { SpinTheWheelStore } from "@/store/SpinTheWheelStore";
import WheelTimer from "@/components/SpinTheWheel/WheelTimer.vue";
import WheelDialog from "@/components/SpinTheWheel/WheelDialog.vue";

const spinTheWheelStore = SpinTheWheelStore();


const openSpinTheWheelDialog = ref(false);
provide('openDialog', openSpinTheWheelDialog);
const openWheel = () => {
    openSpinTheWheelDialog.value = true;
};


const cantSpin = computed(() => {
    return spinTheWheelStore.wheelStatus.cant_spin;
});

const timerEndTime = computed((): number => {
    return spinTheWheelStore.wheelStatus.end_time || 0;
});

</script>